import dayjs from 'dayjs';

export const getFormattedDate =
  (format = 'D MMM') =>
  (date: string): string =>
    date
      .split(' - ')
      .map((item) => dayjs(item, 'YYYY-MM-DD').format(format))
      .join(' - ');
